var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdogwuShareBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1505 12.6734C12.37 11.7936 14.1171 10.2946 15.5188 8.40629C16.0533 7.68611 16.0533 6.70711 15.5188 5.98693C14.1171 4.09861 12.37 2.59965 11.1505 1.7198C10.7678 1.44368 10.259 1.72558 10.259 2.19751V4.46447L7.22331 4.46447C4.79474 4.46447 0.18045 6.65018 1.15188 12.9645C1.75902 11.9526 2.97331 9.92875 7.22331 9.92875H10.259V12.1957C10.259 12.6676 10.7678 12.9495 11.1505 12.6734Z",
    fill: "#D7FD95",
    stroke: "#6DA50A",
    strokeWidth: 1.82143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdogwuShareBtn);
export default __webpack_public_path__ + "static/media/odogwu-share-btn.22a64c74695266ae6673fb8c79521d11.svg";
export { ForwardRef as ReactComponent };